export const AriaRoleType = {
  List: 'list',
  ListBox: 'listbox',
} as const;

export const ItemAriaRoleType = {
  ListItem: 'listitem',
  ListBoxOption: 'option',
} as const;

export const ItemAriaRoleConfig = {
  [AriaRoleType.List]: ItemAriaRoleType.ListItem,
  [AriaRoleType.ListBox]: ItemAriaRoleType.ListBoxOption,
};
